export default function isIE () {
  const ua = window.navigator.userAgent
  const isEvil = ua.indexOf('MSIE ') || ua.indexOf('Trident/')
  // eslint-disable-next-line
  if (isEvil > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/isIE.js